import NotFound from '@/pages/NotFound';
import useUser from '@/hooks/useUser';
import { useNarrativeById } from './hooks/useNarrativeById';
import { PublicNarrativeEdit } from './components/PublicNarrativeEdit';
import { NarrativeLayout } from './NarrativeLayout';
import { useMount } from '@simplywallst/ui-core';
import { useParams } from '@/hooks/location/useParams';

export const PublicNarrativeEditPage = () => {
  const { id: narrativeId } = useParams<{ id: string }>();
  const { data: user } = useUser();
  const { data: narrativeResponse, status } = useNarrativeById(
    { narrativeId },
    {
      enabled: Boolean(narrativeId && user.loggedIn),
    }
  );

  useMount(() => window.scrollTo(0, 0));

  if (!user.loggedIn) {
    return <NotFound />;
  }

  const narrative = narrativeResponse?.NarrativeById;

  return (
    <NarrativeLayout
      title="Edit Narrative"
      isLoading={status === 'pending'}
      error={status === 'error'}
    >
      {narrative && <PublicNarrativeEdit narrative={narrative} />}
    </NarrativeLayout>
  );
};
